"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardContent = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styled_components_1 = __importDefault(require("styled-components"));
const StyledCardContent = (0, styled_components_1.default)(core_1.CardContent) `
  &.primary {
    background: ${props => {
    var _a, _b;
    return ((_b = (_a = props.theme.cardContent) === null || _a === void 0 ? void 0 : _a.background) === null || _b === void 0 ? void 0 : _b.primary) ||
        props.theme.palette.primary.dark;
}};
    color: ${props => props.theme.palette.primary.contrastText};
  }
  &.secondary {
    background: ${props => {
    var _a, _b;
    return ((_b = (_a = props.theme.cardContent) === null || _a === void 0 ? void 0 : _a.background) === null || _b === void 0 ? void 0 : _b.secondary) ||
        props.theme.palette.secondary.dark;
}};
    color: ${props => props.theme.palette.secondary.contrastText};
  }

  &.small {
    padding: 16px;
  }
  &.medium {
    padding: 16px 32px;
    &:last-child {
      padding-bottom: 32px;
    }
  }
  &.large {
    padding: 16px 50px;
    &:last-child {
      padding-bottom: 50px;
    }
  }
  ${props => props.theme.breakpoints.down('sm')} {
    &.small,
    &.medium,
    &.large {
      padding: 16px;
    }
  }
`;
const CardContent = props => {
    const { children, padding = 'small', background } = props;
    const getClassName = () => {
        const classes = [padding];
        if (background) {
            classes.push(background);
        }
        return classes.join(' ');
    };
    return (react_1.default.createElement(StyledCardContent, Object.assign({ className: getClassName() }, props), children));
};
exports.CardContent = CardContent;
exports.default = exports.CardContent;
//# sourceMappingURL=CardContent.js.map